import React, { useEffect, useState, useRef, useContext } from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import { URLBunge } from "./Componentes/Config";
import { LogAcesso, ReactHtmlParser } from "./Componentes/Funcoes";
import CabecalhoPagina from "./Componentes/Cabecalho";
import Carregando from "./Componentes/Carregando";
import MenuPrinc from "./Componentes/MenuPrinc";

import {
  Clear,
  BackgroundImg,
  TitNoticias,
  ColunaRegras,
  LogoMinhaBunge,
  DivItemNoticia,
  BgImgNoticia,
  DivBtsNoticiaNovidades,
  BtNoticiaNovidades,
  BtNoticiaNovidadesSelecionado
} from './Estilos'

function Noticias(props) {

  const history = useHistory();
  const [ Loading, setLoading ] = useState(true);

  const [ NomeEvento, setNomeEvento ] = useState("Minha Bunge Vendas");
  const [ Token, setToken ] = useState(localStorage.getItem("c_token"));

  useEffect(() => {
    if (Token === null) {
        history.push({ pathname: '/', state: {} });
    } else {
        LogAcesso(Token, "Notícias")
        PegaNoticias();
    }
  }, []);

  const [TipoSelecionado, setTipoSelecionado] = useState(0);
  function MudaPesquisa(Tipo) {
      setTipoSelecionado(Tipo)
      if(Tipo === 0){
        LogAcesso(Token, "Noticias")
      } else {
        LogAcesso(Token, "Novidades")
      }
  }

  async function PegaNoticias() {
    
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + Token);
    
    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };
    
    fetch(URLBunge + '/api/Noticias/ListarNoticias', requestOptions)
      .then(response => response.json())
      .then(result => {
        console.log(result);

        if(result.sucesso === true) {
          setLoading(false)
            
          setListaNoticias(result.outNoticias);
          setListaNovidades(result.outNoticias);
          
          if(ListaNoticias.length < 1) {
            setTextoCarregandoNoticias("Não existem notícias")
          }
          if(ListaNovidades.length < 1) {
            setTextoCarregandoNovidades("Não existem novidades")
          }

        }

      })
      .catch(error => console.log('error', error));
    
  }


  const [ListaNoticias, setListaNoticias] = useState([]);
  const [ListaNovidades, setListaNovidades] = useState([]);
  const [TextoCarregandoNoticias, setTextoCarregandoNoticias] = useState("Carregando...");
  const [TextoCarregandoNovidades, setTextoCarregandoNovidades] = useState("Carregando...");
  const [EscondeBtn, setEscondeBtn] = useState(true);

  function ItemNoticia(item, index) {
    return (
        <>
            <DivItemNoticia
            key={index}
            onClick={() => history.push({ pathname: 'noticia/'+item.id, state: {
              itemId: item.id,
              itemTitulo: item.titulo,
              itemImagem: item.caminho,
              noticiasTipoId: item.noticiasTipoId,
            } })}>  
                <BgImgNoticia BgImg={`https://www.plataformaomnion.com.br/UploadsImagens/AppBunge/Noticias/${item.caminho}`} />
                <div className={'TitNoticia'}>{item.titulo}</div>
                <div className={'DesNoticia'}>{item.descricao}</div>
            </DivItemNoticia>
        </>
    )
  }

  return (
    <>  
        <CabecalhoPagina NomeEvento={NomeEvento} />
        {Loading === true ? <Carregando /> : null }

        <BackgroundImg Background={''} BackgroundMob={''} bgcolor={'#FFFFFF'}>
        {/* <BackgroundImg Background={BgRegras} BackgroundMob={BgRegras} bgcolor={'#3c647d'}> */}

            
            <ColunaRegras>
                <div className={'AreaColunaRegras'}>

                    <TitNoticias>Notícias e Novidades</TitNoticias>

                    <DivBtsNoticiaNovidades>
                      {TipoSelecionado == 0 ?
                        <BtNoticiaNovidadesSelecionado>NOTÍCIAS</BtNoticiaNovidadesSelecionado>
                      :
                        <BtNoticiaNovidades onClick={()=>MudaPesquisa(0)}>NOTÍCIAS</BtNoticiaNovidades>
                      }
                      {TipoSelecionado == 1 ?
                        <BtNoticiaNovidadesSelecionado>NOVIDADES</BtNoticiaNovidadesSelecionado>
                      :
                        <BtNoticiaNovidades onClick={()=>MudaPesquisa(1)}>NOVIDADES</BtNoticiaNovidades>
                      }                      
                    </DivBtsNoticiaNovidades>

                    <Clear />


                    {TipoSelecionado === 0 ?
                      <>
                        {
                            ListaNoticias.length > 0 ?
                            <div>
                              {ListaNoticias.map((item, index) => {
                                  return ( item.noticiasTipoId === 1 ? ItemNoticia(item, index) : null )
                              })}
                            </div>
                            :
                            <div>{TextoCarregandoNoticias}</div>
                        }  
                      </>
                    :
                      <>
                        {
                            ListaNovidades.length > 0 ?
                            <div>
                              {ListaNovidades.map((item, index) => {
                                  return ( item.noticiasTipoId === 2 ? ItemNoticia(item, index) : null )
                              })}
                            </div>
                            :
                            <div>{TextoCarregandoNoticias}</div>
                        }
                      </>
                    }

                </div>  
            </ColunaRegras>
            
            <MenuPrinc Pagina="Noticias" />
         </BackgroundImg>
    </>
  );

}

export default Noticias;
